// extracted by mini-css-extract-plugin
export default {"richMediaContainer":"RichMedia_richMediaContainer__fQSnF","richMediaTitle":"RichMedia_richMediaTitle__8S2Q2","richMediaBullets":"RichMedia_richMediaBullets__EJOZs"};